import { useCallback } from 'react';
import { authenticatedFetch } from '../../../../utils/api';
import { TOKEN_REFRESH_MARGIN_MS } from '../utils/dashboardHelpers';

const embedInfoCache = new Map();

const isCacheEntryValid = (entry) =>
    !!entry && Date.now() < entry.expiresAtMs - TOKEN_REFRESH_MARGIN_MS;

export const clearEmbedToken = (reportId) => {
    embedInfoCache.delete(reportId);
};

export const useEmbedToken = () => {
    const getEmbedInfo = useCallback(async (reportId, { forceRefresh = false } = {}) => {
        const cached = embedInfoCache.get(reportId);
        if (!forceRefresh && isCacheEntryValid(cached)) return cached.embedInfo;

        const res = await authenticatedFetch('/ManagerReport/GetDashboardEmbedToken', {
            method: 'POST',
            body: JSON.stringify({ reportId }),
        });
        if (!res.ok) throw new Error('Failed to retrieve dashboard access');

        const embedInfo = await res.json();
        embedInfoCache.set(reportId, {
            embedInfo,
            expiresAtMs: new Date(embedInfo.expiresAt).getTime(),
        });
        return embedInfo;
    }, []);

    return { getEmbedInfo };
};
